
import { defineComponent } from "vue";
import Shares from "@/components/Shares.vue";

import Cookies from "js-cookie";
export default defineComponent({
  setup() {
    // dirty fix for .net backend XSRF-TOKEN acception
    if (Cookies.get("XSRF-TOKEN"))
    {
      Cookies.set("XSRF-TOKEN", "", {
        sameSite: "strict",
      });
    }
  },
  components: { Shares },
});
